/**
 * type of barrels
 */
export type BarrelType =
  | 'FRENCH_OAK_BARREL'
  | 'OAK_BARREL'
  | 'EX_SHERRY_CASK'
  | 'OTHER';

export const BarrelType = {
  FrenchOakBarrel: 'FRENCH_OAK_BARREL' as BarrelType,
  OakBarrel: 'OAK_BARREL' as BarrelType,
  ExSherryCask: 'EX_SHERRY_CASK' as BarrelType,
  Other: 'OTHER' as BarrelType,
};
